import { render, staticRenderFns } from "./UserAlbum.vue?vue&type=template&id=6d935a67&scoped=true&"
import script from "./UserAlbum.vue?vue&type=script&lang=js&"
export * from "./UserAlbum.vue?vue&type=script&lang=js&"
import style0 from "./UserAlbum.vue?vue&type=style&index=0&id=6d935a67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d935a67",
  null
  
)

export default component.exports